import { CMSLink } from '~/shared/components';
import styles from './mini-basket-icon.module.css';
import { useFrame, useTranslation } from '~/shared/utils';
import Basket from '$icons/solidAsh/shopping-cart.svg';
import { useBasket } from '~/features/basket';
import clsx from 'clsx';

type Props = {
    isQuantityDark?: boolean;
};

export const MiniBasketIcon = ({ isQuantityDark }: Props) => {
    const { translate } = useTranslation();
    const { data: basket, totalQuantity } = useBasket();
    const { data } = useFrame();

    const { lines = [] } = basket || {};

    return (
        <div className={styles.root}>
            <CMSLink href={data?.staticLinks?.basketPage?.url || ''} className={styles.link}>
                <div className={styles.iconWrapper}>
                    <Basket aria-hidden="true" />
                    {lines?.length ? (
                        <span
                            className={clsx(styles.quantity, { [styles.dark]: isQuantityDark })}
                            children={totalQuantity}
                        />
                    ) : null}
                </div>
            </CMSLink>
            <span className={styles.tooltipText}>{translate('navigation.mainMenu.basket')}</span>
        </div>
    );
};
